
<template>
  <div class="main_right col-lg-9 col-md-6 col-sm-6 el-col-xs-12 row w-100">
    <div class="main_right_item col-lg-4 col-md-6 col-sm-6" v-for="(item,index) in product_detail.slice((currentPage- 1)*pagesize,currentPage*pagesize)" 
    :key="index">
      <div>
        <img class="w-100" :src="`http://www.waternaida.com/${item.image}`" alt />
        <router-link :to="{path:'/product_item',query:{id:item.id}}"> 
          <div class="main_right_link w-100 w-100">
            <img style="position: absolute; left:45%; top: 50%;" src="../../img/product/链接.png" alt />
            <span
              class="main_right_link_txt"
              style="position: absolute; left:35%; top: 70%;"
            >{{item.name}}</span>
          </div>
        </router-link>
        <span class="pb-2">{{item.name}}</span>
      </div>
    </div>
    <el-pagination class="main_download1_pag" background 
    layout="prev, pager, next" 
    :page-size="pagesize" 
     @current-change="current_change"
     :current-page.sync="currentPage" 
     :pager-count="5"
     :total="product_detail.length">
    </el-pagination>
  </div>
</template>
<style scoped>
  .main_right_link_txt{
    color: white;
}
.main_right_link {
    background: black;
    position: absolute;
    z-index: 999;
    top:0;
    bottom: 0;
    opacity: 0;
}
.main_download1_pag{
    width: 100%;
    text-align:right;
}
.main_right_link:hover {
    opacity: 0.3;
}
.main_right {
  width: 100%;
  margin: 0 auto;
}
.main_right_item{
    padding-bottom: 2%;
    padding-right: 1%;
    padding-left: 1%;
    height: 0px;
}
.main_right_item>div {
  box-shadow: 0px 1px 5px #888888;
  position: relative;
}
.main_right_item:hover>div>span{
  color: #fff;
}
</style>
<script>
export default {
  data() {
    return {
      product_detail:[],
      pagesize:9,//每页多少数据
      currentPage:1
    };
  },
  methods: {
    // item_href() {
    //   this.$router.push({ path: "/product_item",query:{id:id} });
    // },
    current_change(currentPage){  //改变当前页
             this.currentPage = currentPage
         }
  },
  created(){
    this.axios.get('/api/product/prolist?classifyID=23&page=1&perNum=11&language=1').then((res)=>{
      this.product_detail=res.data.proList
      console.log(this.product_detail)
    }).catch((err)=>{
      console.log(err)
    })
  }
};
</script>


// WEBPACK FOOTER //
// src/components/zzj/domestic.vue